<template>
  <div class="common-table">
    <a-spin :spinning="loading" style="background: #fff;">
      <a-skeleton v-show="loading" :paragraph="{rows: 10}" />
    </a-spin>
    <div v-show="!loading">
      <a-card :bordered="false">
        <customer-summary v-if="basicData" :initData="basicData" :countryList="countryList"></customer-summary>
      </a-card>
      <div :style="{ display: !isShowEdit ? 'flex' : '' }">
        <div>
          <div class="tabs-define-box">
            <a-tabs type="card" :activeKey="currentActiveTabKey" @change="handleTabChange" style="padding-bottom: 0;padding-top: 0;">
              <a-tab-pane key="1" tab="Profile" :forceRender="true" class="profile-tab">
                <div class="custom-section-box">
                  <div class="ant-advanced-search-form item" style="padding-top: 12px;">
                    <div :style="!isMergeMode ? { display: 'table', position: 'relative' } : { position: 'relative' }">
                      <a class="edit-icon" @click="handleToggleChange" :style="{color: isEditShow ? '' : '#333'}" v-if="!isShowEdit">
                        <a-icon :type="isEditShow ? 'edit' : 'close'" />
                      </a>
                      <cdb-basic-merge
                        ref="basicMergeComponent"
                        v-if="isMergeMode && basicData && emergencyContact"
                        :initData="basicData"
                        :initEmergencyContact="emergencyContact"
                        :countryList="countryList"
                        :titleList="titleList"
                        :backgroundList="backgroundList"
                        :ethnicitiesList="ethnicitiesList"
                        :languageList="languageList"
                        :realationShipList="realationShipList"
                        :isMainShow="isMainShow"
                        :tourData="tourData"
                        @update="handleUpdate"
                      ></cdb-basic-merge>
                      <template v-else>
                        <cdb-basic
                          v-if="isEditShow && basicData && emergencyContact"
                          :initData="basicData"
                          :initEmergencyContact="emergencyContact"
                          :titleList="titleList"
                          :backgroundList="backgroundList"
                          :ethnicitiesList="ethnicitiesList"
                          :languageList="languageList"
                          :realationShipList="realationShipList"
                        ></cdb-basic>
                        <div v-else>
                          <cdb-basic-edit
                            ref="basicComponent"
                            v-if="basicData && emergencyContact"
                            :initData="basicData"
                            :initEmergencyContact="emergencyContact"
                            :countryList="countryList"
                            :titleList="titleList"
                            :backgroundList="backgroundList"
                            :ethnicitiesList="ethnicitiesList"
                            :languageList="languageList"
                            :realationShipList="realationShipList"
                            @cancel="isEditShow = true"
                            @update="handleUpdate"
                          ></cdb-basic-edit>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="2" tab="Travel Documents" :forceRender="true" v-if="record && record !== ''">
                <cdb-passport-page
                  ref="passportPage"
                  :customerId="record.id"
                  :customerBirthday="record.birthday"
                  :isShowEdit="isShowEdit"
                  :isMainShow="isMainShow"
                  @update="handleCustomerTourChange"
                ></cdb-passport-page>
              </a-tab-pane>
              <a-tab-pane key="3" tab="Tour" :forceRender="true" v-if="record && record !== ''">
                <customer-tour
                  ref="tourComponent"
                  :customerId="record.id"
                  :isShowEdit="isShowEdit"
                  :isMainShow="isMainShow"
                  :webSiteType="webSiteType"
                  @web-site-type-change="handleWebSiteTypeChange"
                  @update="handleCustomerTourChange"
                ></customer-tour>
              </a-tab-pane>
              <a-tab-pane key="4" tab="Coupon" :forceRender="true" v-if="record && record !== ''">
                <customer-coupon
                  ref="couponComponent"
                  :record="record"
                  :isShowEdit="isShowEdit"
                  :isMainShow="isMainShow"
                  :webSiteType="webSiteType"
                  @web-site-type-change="handleWebSiteTypeChange"
                  @update="handleCustomerTourChange"
                ></customer-coupon>
              </a-tab-pane>
            </a-tabs>
          </div>
          <div :bordered="false" v-if="record && record !== '' && !isShowEdit" class="custom-section-box" style="margin: 0 10px;">
            <div class="item" style="padding-bottom: 10px;">
              <div class="title" style="padding-top:12px;">Profile Activity Log 
                <a href="javascript:void(0);" @click="showActivityLog = !showActivityLog">
                  <a-icon :type="showActivityLog ? 'up' : 'down'" />
                </a>
              </div>
              <transition name="slide">
                <cdb-logs
                  v-if="showActivityLog"
                  :languageList="languageList"
                  :ethnicitiesList="ethnicitiesList"
                  :backgroundList="backgroundList"
                  :countryList="countryList"
                  :customerId="record.id"
                  :realationShipList="realationShipList"
                  ref="cdbLogs"
                ></cdb-logs>
              </transition>
            </div>
          </div>
        </div>
        <div style="padding-top: 30px;max-width: 300px;" v-if="nextTourData && !isShowEdit">
          <a-card :bordered="false">
            <div style="display: flex;white-space: nowrap;">
              <a-icon type="schedule" style="font-size: 24px;color: green;"/>
              <div style="font-weight: bold;color: #212529;margin-left: 10px;">
                <div style="font-size: 18px;">Upcoming Tour</div>
                <div style="margin-top: 6px;">
                  <div v-if="nextTourData.tourCode" style="font-size: 14px;">
                    <div>Tour Code: <span style="font-weight: normal;">{{ nextTourData.tourCode }}</span></div>
                    <div>Date: <span style="font-weight: normal;">{{ dateFormatB(nextTourData.tourStartDate) }}</span></div>
                  </div>
                  <div v-else>N/A</div>
                </div>
              </div>
            </div>
          </a-card>
          <a-card :bordered="false">
            <div style="display: flex;">
              <div style="color: #212529;">
                <div style="display: flex;">
                  <div style="font-size: 18px;font-weight: bold;margin-right: 10px;">Note</div>
                  <a href="javascript:;" @click="isModalShow = true, specialNote = internalNoteData.noteMsg" style="font-size: 16px;"><a-icon type="edit" /></a>
                </div>
                <div style="margin-top: 6px;">
                  <div v-if="internalNoteData && internalNoteData.id" style="font-size: 14px;">
                    {{ internalNoteData.noteMsg }}
                    <!-- <ul style="padding-left: 20px;">
                      <li v-for="(note, index) in internalNoteList" :key="index" style="margin-bottom: 5px;">
                        {{ note.noteMsg }} - {{ dateFormatB(note.createDate) }}
                      </li>
                    </ul> -->
                  </div>
                  <div v-else>
                    N/A
                  </div>
                </div>
              </div>
            </div>
          </a-card>
        </div>
      </div>
    </div>
    <a-modal
      title="Edit"
      :destroyOnClose="true"
      :visible="isModalShow"
      :maskClosable="false"
      @cancel="() => { this.isModalShow = false }"
    >
      <a-form-model :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
        <a-form-model-item label="Note">
          <a-textarea
            v-model="specialNote"
            auto-size
          />
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button type="primary" :loading="confirmLoading" @click="handleNoteSave">
          Save
        </a-button>
        <a-button @click="() => { this.isModalShow = false }">
          Close
        </a-button>
      </template>
    </a-modal>
    <footer-tool-bar class="footerBox" v-if="!isShowEdit">
      <!-- <a-button type="primary" html-type="submit" :loading="saving" @click="handleSubmit">Save</a-button> -->
      <a-button :loading="saving" v-if="!editMode" @click="handleGoBack">Close</a-button>
      <a-button :loading="saving" v-else @click="handleClose">Close</a-button>
    </footer-tool-bar>
  </div>
</template>

<script>
import '@/assets/css/common-table-list.css'
import '@/assets/css/footer.css'
import moment from 'moment'
import FooterToolBar from '@/components/FooterToolbar'
import CdbBasic from './components/CdbCustomerBasic'
import CdbBasicEdit from './components/CdbCustomerBasicEidt'
import CustomerSummary from './components/CdbCustomerSummary'
import CustomerTour from './components/CdbCustomerTourPage'
import CustomerCoupon from './components/CdbCustomerCoupon'
import CustomerApi from '@/api/api-cdb-custome-v2'
import CountryApi from '@/api/basicdata/api-country'
import pick from 'lodash.pick'
import CdbLogs from './components/CdbCustomerLogs'
import CdbPassportPage from './components/CdbCustomerPassportPage'
import CdbBasicMerge from './components/CdbCustomerBasicMerge'
import { Title } from '@/utils/helper/standard-code-utils'
import { Language, Background, Ethnicities} from '@/utils/helper/dict-cdb-utils'
const getDefaultFormData = () => {
  return { id: null, firstName: null, lastName: null, preferToBeCalled: null, fullName: null,  middleName: null, gender: 'M', birthday: null, companyCode: 'signet' }
}

export default {
  name: 'CdbCustomerEdit',
  components: {
    FooterToolBar,
    CdbBasic,
    CustomerSummary,
    CustomerTour,
    CustomerCoupon,
    CdbLogs,
    CdbPassportPage,
    CdbBasicEdit,
    CdbBasicMerge
  },
  props: {
    record: {
      type: [String, Object],
      default: null
    },
    // 是否直接链接进入编辑模式
    editMode: {
      type: [Boolean],
      default: false
    },
    isShowEdit: {
      type: [Boolean],
      default: false
    },
    activeTabKey: {
      type: String,
      default: '1'
    },
    isMainShow: {
      type: Boolean,
      default: true
    },
    webSiteType: {
      type: String,
      default: 'Signet'
    },
    isMergeMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      saving: false,
      loading: false,
      confirmLoading: false,
      editData: this.tourData,
      // 基础数据
      basicData: getDefaultFormData(),
      // 行程相关数据
      tourData: null,
      // 紧急联系人
      emergencyContact: null,
      countryList: [],
      isEditShow: true,
      titleList: Title.dict,
      backgroundList: [],
      ethnicitiesList: [],
      languageList: [],
      nextTourData: null,
      internalNoteData: null,
      isModalShow: false,
      specialNote: null,
      realationShipList: [],
      showActivityLog: false,
      currentActiveTabKey: '1'
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    async initData () {
      this.loading = true
      this.record ? this.isEditShow = true : this.isEditShow = false
      !this.isShowEdit ? this.currentActiveTabKey = this.activeTabKey : this.currentActiveTabKey = '1'

      try {
        // 加载国家数据
        const resCountry = await CountryApi.list()
        const countryList = resCountry.data
        this.countryList = countryList
        this.languageList = await Language.getDict()
        this.backgroundList = await Background.getDict()
        this.ethnicitiesList = await Ethnicities.getDict()

        this.basicData = null
        const record = this.record
        let formData = null
        let tourData = null
        let emergencyContact = {firstName: null, lastName: null, phoneCountryCode: null, phoneCountryCallingCode: null, phoneNumber: null, phoneExt: null, email: null, realationShip: 'Z'}
        if (!record || record === '') {
          // 新增 初始化默认值
          formData = getDefaultFormData()
          tourData = { id: null, mealsRequest: null, specialRequest: null, specialNote:null,roomPreferred:null }
        } else {
          // 修改 加载后台完整数据
          const [detailRes, comingTourRes, internalNoteRes, relationshipRes] = await Promise.all([
            CustomerApi.detail(record.id),
            CustomerApi.getCusComingTour(record.id),
            CustomerApi.getCusInternalNote(record.globalCode),
            CustomerApi.getCusRelationshipList()
          ])
          
          const resData = detailRes.data
          formData = pick(resData, ['id', 'fullName', 'firstName', 'lastName', 'middleName', 'gender', 'preferToBeCalled', 'referralBy', 'referralByOthers',
          'birthday', 'title', 'phoneCountryCode', 'phoneCountryCallingCode', 'phoneNumber', 'phoneExt',
          'email', 'languages', 'nationalBackground', 'ethnicitiesId', 'companyCode', 'addressList', 'passportList', 'signetCustomerCode', 'superaCustomerCode', 'signetMembership', 'superaMembership', 'contactList', 'globalCode', 'otherLanguages', 'rsList'])
          tourData = pick(resData, ['id', 'mealsRequest', 'specialRequest', 'specialNote', 'roomPreferred', 'signetCdbCustomer', 'superaCdbCustomer' ])
          if(resData.emergencyContact) {
            emergencyContact = resData.emergencyContact
          }
          this.nextTourData = comingTourRes.data
          this.internalNoteData = internalNoteRes.data
          this.realationShipList = relationshipRes.data
        }
        this.basicData = formData
        this.tourData = tourData
        this.emergencyContact = emergencyContact
      } catch (e) {
        console.log('e', e)
      } finally {
        this.loading = false
        this.$emit('data-loaded')
      }
    },
    handleTabChange (key) {
      this.currentActiveTabKey = key
      this.$emit('tab-change', key)
    },
    handleWebSiteTypeChange (value) {
      this.$emit('web-site-type-change', value)
    },
    handleGoBack () {
      this.loading = true
      this.$emit('onGoBack')
    },
    async handleSubmit (e) {
      e.preventDefault()
      this.saving = true
      // 读取basic内容
      const basicComponentPromise = this.$refs.basicComponent.validateBasicForm
      let formData = null
      try {
        formData = await basicComponentPromise()
      } catch (e) {
        if (e) {
          console.log('warnning:', e.message)
        }
        this.saving = false
        return
      }
      formData.birthday = moment(formData.birthday).format('YYYY-MM-DD')
      // 读取tour内容
      if (this.$refs.tourComponent && this.$refs.tourComponent.validateTourForm) {
        const tourComponentPromise = this.$refs.tourComponent.validateTourForm
        const tourFormData = await tourComponentPromise()
        formData.mealsRequest = tourFormData.mealsRequest
        formData.specialRequest = tourFormData.specialRequest
        formData.specialNote = tourFormData.specialNote
        formData.roomPreferred = tourFormData.roomPreferred
      }
      // 添加
      if (formData.id === null) {
        CustomerApi.add(formData).then(res => {
          if (!this.mixinProcessHasBizErrorNotification(res)) {
            this.mixinProcessSuccessNotification('Save successfully !')
            this.handleGoBack()
          }
        }).finally(() => {
          this.saving = false
        })
      }
      // 修改
      if (formData.id !== null) {
        CustomerApi.update(formData.id, formData).then(res => {
          if (!this.mixinProcessHasBizErrorNotification(res)) {
            this.mixinProcessSuccessNotification('Update successfully !')
            if (!this.editMode) {
              this.handleGoBack()
            }
          }
        }).finally(() => {
          this.saving = false
        })
      }
    },
    // 处理CustomerTour变化
    handleCustomerTourChange () {
      if (this.$refs.cdbLogs && this.$refs.cdbLogs.refreshCurrentPage) {
        this.$refs.cdbLogs.refreshCurrentPage()
      }
    },
    handleToggleChange () {
      this.isEditShow = !this.isEditShow
    },
    handleClose () {
      window.close()
    },
    handleUpdate (basicData, emergencyContact, type) {
      this.basicData = basicData
      this.emergencyContact = emergencyContact
      if (type == 'add') {
        this.handleGoBack()
      } else {
        this.isEditShow = true
      }
      this.handleCustomerTourChange()
    },
    handleNoteSave () {
      this.confirmLoading = true
      CustomerApi.saveCusInternalNote(this.record.globalCode, {noteMsg: this.specialNote}).then(res => {
        if (!this.mixinProcessHasBizErrorNotification(res)) {
          this.mixinProcessSuccessNotification('Save success !')
          this.queryNote()
          this.confirmLoading = false
          this.isModalShow = false
        }
      }).catch(() => {
        this.confirmLoading = false
      })
    },
    async queryNote () {
      try {
        const res = await CustomerApi.getCusInternalNote(this.record.globalCode)
        this.internalNoteData = res.data
      } catch (e) {
        console.log('e', e)
        
      }
    }
  },
  watch: {
    record() {
      this.initData()
    }
  }
}
</script>
<style lang="less" scoped>
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
  max-height: 1000px;
  overflow: hidden;
}
.slide-enter, .slide-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
::v-deep .ant-advanced-search-form {
  padding-top: 16px;
}
.profile-tab {
  .edit-icon {
    font-size: 16px;
    position: absolute;
    right: 0;
    top: 4px;
    cursor: pointer;
    z-index: 1;
  }
}
::v-deep .ant-tabs {
  overflow: visible;
}
::v-deep .ant-tabs-bar {
  margin: 0;
}
::v-deep .ant-advanced-search-form .ant-form-item {
  margin-bottom: 0;
}
::v-deep .ant-col .ant-form-item-label {
  line-height: 30px;
}
</style>